import { AdvancedLabel, ControlDialog } from '@mosanic/items';

import CoreContext from '@context/CoreContext';
import { Button } from '@mosanic/fields/Button/Buttons';
import { useContext } from "react";
import { GetListOfMedia } from "./Resolvers/GetListOfMedia";
import { useFieldSource, useInspectedAttr } from '@mosanic/hooks';




const BuilderMedia = () => {
    const cContext = useContext(CoreContext);
    
    const {type} = useInspectedAttr('type') || {type: null}
    const {source, handler} = useFieldSource({
        // basePath: 'fields.[field]', 
        path: type === 'video' ? 'fields.videoUrl' : 
            type === 'image' ? 'fields.imageUrl' : 
            'data.image'
    }, false); 

    return (
        <ControlDialog
            state={cContext.mediaModal} 
            close={() => cContext.setMediaModal(false)} 
            size="md" 
            fullWidth={true}
        > 

            <GetListOfMedia header dialog initiate={handler} upload={false}/>
            
            <Button onClick={() => cContext.setMediaModal(false)} size="small" >
                Close 
            </Button>
        </ControlDialog>
    );
};
export default BuilderMedia;